
 <div cdkDropList
 (cdkDropListDropped)="onDrop($event)"
 [cdkDropListData]="ownedAnimals">
    <div cdkDrag class="drag-item" *ngFor="let animal of ownedAnimals;let i=index;">
       {{i+1}} {{animal.Name}}
    </div>
 </div>
 <button type="button" class="btn btn-sm">
    <i class="fa-thin fa-arrow-up-right"></i>
</button>